import React from 'react';
import { Link } from 'react-router-dom';

const paths = {
  arrow: <path d="M5 12h14m-6-6 6 6-6 6" />,
  back: <path d="M19 12H5m6-6-6 6 6 6" />,
  blocks: (
    <>
      <path d="m12 3 4 2.2v4.6L12 12 8 9.8V5.2L12 3Z" />
      <path d="m7 12 4 2.2v4.6L7 21l-4-2.2v-4.6L7 12Zm10 0 4 2.2v4.6L17 21l-4-2.2v-4.6l4-2.2Z" />
    </>
  ),
  check: <path d="m5 12 4 4L19 6" />,
  chevronDown: <path d="m7 9 5 5 5-5" />,
  close: <path d="M6 6l12 12M18 6 6 18" />,
  copy: (
    <>
      <rect x="8" y="8" width="11" height="11" rx="2" />
      <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m15.5 8.5-2 5-5 2 2-5 5-2Z" />
    </>
  ),
  document: (
    <>
      <path d="M6 3h9l4 4v14H6V3Z" />
      <path d="M14 3v5h5M9 13h6M9 17h4" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v12m-5-5 5 5 5-5" />
      <path d="M5 20h14" />
    </>
  ),
  edit: (
    <>
      <path d="m14 5 5 5M4 20l3.5-.8L19 7.7a2.1 2.1 0 0 0-3-3L4.8 16.2 4 20Z" />
    </>
  ),
  flask: (
    <>
      <path d="M9 3h6m-5 0v6l-5 8.3A2.4 2.4 0 0 0 7.1 21h9.8a2.4 2.4 0 0 0 2.1-3.7L14 9V3" />
      <path d="M8 15h8" />
    </>
  ),
  home: (
    <>
      <path d="m3 11 9-8 9 8" />
      <path d="M5 10v11h14V10M9 21v-7h6v7" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v6m0-10h.01" />
    </>
  ),
  leaf: (
    <>
      <path d="M20 4C11 4 5 8 5 14c0 3 2 5 5 5 6 0 10-6 10-15Z" />
      <path d="M4 21c2-5 6-8 12-11" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="10" width="14" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  rocket: (
    <>
      <path d="M14 5c3-2 6-2 6-2s0 3-2 6l-6 6-4-4 6-6Z" />
      <path d="m8 11-4 1 3 2m5 1-1 5-2-3m6-9h.01" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3 20 6v6c0 5-3.2 8-8 10-4.8-2-8-5-8-10V6l8-3Z" />
      <path d="m8.5 12 2.2 2.2 4.8-5" />
    </>
  ),
  signal: (
    <>
      <path d="M4 20V9m6 11V4m6 16v-7m6 7H2" />
    </>
  ),
  spark: (
    <>
      <path d="m12 3 1.4 4.1L17.5 9l-4.1 1.4L12 14.5l-1.4-4.1L6.5 9l4.1-1.9L12 3Z" />
      <path d="m19 14 .8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8L19 14Z" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M3 20v-2a5 5 0 0 1 10 0v2m1-6a4.5 4.5 0 0 1 7 3.8V20" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </>
  ),
};

export const ProgrammeIcon = ({ name, size = 24, className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
    >
      {paths[name] || paths.spark}
    </g>
  </svg>
);

export const ProgrammeAction = ({
  children,
  className = '',
  icon = 'arrow',
  to,
  variant = 'primary',
}) => (
  <Link className={`pj-action pj-action--${variant} ${className}`} to={to}>
    {children}
    <ProgrammeIcon name={icon} size={18} />
  </Link>
);

export const ProgrammeLogo = ({ compact = false }) => (
  <Link
    aria-label="Supernova Lab home"
    className={`pj-logo ${compact ? 'pj-logo--compact' : ''}`}
    to="/"
  >
    <img alt="Supernova Lab" src="/assets/images/logo.svg" />
  </Link>
);
